module.exports = __webpack_public_path__ + "img/boc.8574f604.png";